import confetti from "canvas-confetti";

const PATTERNS = {
  tap: [10],
  success: [15, 50, 25],
  error: [40, 60, 40, 60],
  warning: [30],
  scan_received: [20, 30, 10],
  delivered: [20, 40, 30],
};

export const triggerHaptic = (type = "tap") => {
  try {
    if (!interacted) return;
    if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
      navigator.vibrate(PATTERNS[type] || PATTERNS.tap);
    }
  } catch { /* unsupported */ }
};

// Browsers block vibrate() before the first user gesture — track it once.
let interacted = false;
if (typeof window !== "undefined") {
  const mark = () => { interacted = true; };
  ["pointerdown", "keydown", "touchstart"].forEach((ev) => window.addEventListener(ev, mark, { once: true, capture: true, passive: true }));
}

const reduced = () => typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
const COLORS = ["#214FD8", "#E6193C", "#F97316", "#10B981", "#06B6D4"];

export const celebrate = (kind = "success") => {
  triggerHaptic(kind === "delivered" ? "delivered" : "success");
  if (reduced()) return;
  if (kind === "delivered") {
    confetti({ particleCount: 140, spread: 80, origin: { y: 0.6 }, colors: COLORS, zIndex: 9999 });
    setTimeout(() => confetti({ particleCount: 60, angle: 60, spread: 55, origin: { x: 0, y: 0.7 }, colors: COLORS, zIndex: 9999 }), 180);
    setTimeout(() => confetti({ particleCount: 60, angle: 120, spread: 55, origin: { x: 1, y: 0.7 }, colors: COLORS, zIndex: 9999 }), 320);
  } else {
    confetti({ particleCount: 90, spread: 70, origin: { y: 0.7 }, colors: COLORS, scalar: 0.9, zIndex: 9999 });
  }
};
